// we don't do any error checking on props, we assume the caller has done that already
// color (string), width (number of pixels), and height (number of pixels) should always be specified
const Icon = (props) => (
	<>
		<svg
			width={props.width}
			height={props.height}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M23 1H1V23H23V1ZM14.6749 17.568C15.1982 17.856 15.8138 18 16.5218 18C17.2297 18 17.8402 17.856 18.3532 17.568C18.8765 17.28 19.2818 16.88 19.5691 16.368C19.8564 15.8453 20 15.2373 20 14.544V9.456C20 8.752 19.8564 8.144 19.5691 7.632C19.292 7.12 18.8919 6.72 18.3686 6.432C17.8556 6.144 17.24 6 16.5218 6C15.8138 6 15.1982 6.144 14.6749 6.432C14.1516 6.72 13.7464 7.12 13.4591 7.632C13.1821 8.144 13.0435 8.752 13.0435 9.456V14.544C13.0435 15.2373 13.1872 15.8453 13.4745 16.368C13.7618 16.88 14.1619 17.28 14.6749 17.568ZM17.8915 15.968C17.5529 16.3307 17.0963 16.512 16.5218 16.512C15.9472 16.512 15.4855 16.3307 15.1366 15.968C14.798 15.6053 14.6288 15.1307 14.6288 14.544V9.456C14.6288 8.86933 14.798 8.39467 15.1366 8.032C15.4855 7.66933 15.9472 7.488 16.5218 7.488C17.0963 7.488 17.5529 7.66933 17.8915 8.032C18.2404 8.39467 18.4148 8.86933 18.4148 9.456V14.544C18.4148 15.1307 18.2404 15.6053 17.8915 15.968ZM15.8138 12.704C15.9985 12.896 16.2345 12.992 16.5218 12.992C16.8091 12.992 17.0399 12.896 17.2143 12.704C17.399 12.512 17.4914 12.2613 17.4914 11.952C17.4914 11.6533 17.399 11.4133 17.2143 11.232C17.0399 11.04 16.8091 10.944 16.5218 10.944C16.2345 10.944 15.9985 11.04 15.8138 11.232C15.6394 11.4133 15.5522 11.6533 15.5522 11.952C15.5522 12.2613 15.6394 12.512 15.8138 12.704ZM4.01539 16.304V17.84H11.0796V16.304H8.66329V6.16H6.5702L4 8.112V9.984L7.00113 7.664V16.304H4.01539Z"
				fill={props.color}
			/>
		</svg>
	</>
);

export default Icon;
